import {t} from "@lingui/core/macro";
import {lazy} from "react";

import {color} from "@khanacademy/wonder-blocks-tokens";

import {Layout, ToolCategories, type Tool} from "../types.ts";

import chatCircleTextIcon from "@phosphor-icons/core/regular/chat-circle-text.svg";

const ChatOnlyTool = lazy(() => import("../renderers/chat-only-tool.tsx"));

export const chatWithGpt: Tool = {
    urlSlug: "chat-with-gpt",
    configName: "activity-chat-with-gpt",
    title: () => t`Chat with GPT`,
    description: () => t`Have a conversation with the GPT-4o mini model`,
    categories: [ToolCategories.Learn],
    icon: chatCircleTextIcon,
    color: color.fadedGold24,
    layout: Layout.ChatOnly,
    extensionOrder: 1,
    activitySlug: "activity-chat-with-gpt",
    reportingLabelId: "chat-with-gpt4-teacher",
    requestedInputs: [],
    component: ({configName}) => <ChatOnlyTool configName={configName} />,
};
